import { defineMessages, useIntl } from 'react-intl';

import { MAIN_CONTENT_ID } from '@/components/accessibility/SkipToMain';
import { useAnalytics } from '@/hooks/analytics';

import CalmGradientText from '../CalmGradientText';
import { BuyBox, BuyButton, Container } from './styles';

const messages = defineMessages({
	description: {
		id: 'book.buy.description',
		defaultMessage: 'Now available on Amazon',
		description: 'Telling user that they can buy a book on Amazon',
	},
	purchase: {
		id: 'purchaseBook',
		defaultMessage: 'Purchase',
		description: 'Link to purchase book from amazon',
	},
});

interface BuyProps {
	bookBuyURL: string;
}

const Buy = ({ bookBuyURL }: BuyProps) => {
	const { logEvent } = useAnalytics();
	const { formatMessage } = useIntl();

	const onClickBuy = () => {
		logEvent({
			eventName: 'Book : Buy : Clicked',
			eventProps: {
				url: bookBuyURL,
			},
		});
		window.open(bookBuyURL);
	};
	return (
		<Container id={MAIN_CONTENT_ID}>
			<BuyBox>
				<div>
					<CalmGradientText text={formatMessage(messages.description)} />
				</div>
				<BuyButton aria-label="Purchase book from Amazon" onPress={onClickBuy}>
					{formatMessage(messages.purchase)}
				</BuyButton>
			</BuyBox>
		</Container>
	);
};

export default Buy;
